export { clearError, setError, setSuccess, setProcessing } from '@/store/generic/mutations/result-status';

export function setUserLogin(state, userLogin) {
  state.userLogin = userLogin;
}
